import { z } from "zod";

export const CampaignIdSchema = z.number().min(1).brand<'CampaignId'>();

export type CampaignId = z.infer<typeof CampaignIdSchema>;
